import { finalize } from 'rxjs/operators';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, Pipe, Input } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { FAQServiceProxy, GetFAQForHomeViewDto } from '@shared/service-proxies/service-proxies';
import { DateTime } from 'luxon';
import { result } from 'lodash-es';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'faq-item',
  templateUrl: './faq-item.component.html',
  styleUrls: ['./faq-item.component.css'],
  animations: [appModuleAnimation()]
})

export class FaqItemComponent extends AppComponentBase implements OnInit {
  @Input() categoryId: number
  faqlist: Array<GetFAQForHomeViewDto> = new Array<GetFAQForHomeViewDto>();
  constructor(injector: Injector,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _faqServiceProxy: FAQServiceProxy
  ) {
    super(injector);
  }

  ngOnInit() {
    this._faqServiceProxy.getAllFAQByCategoryId(this.categoryId).pipe(finalize(() => { })).subscribe((faqsResult) => {
      this.faqlist = faqsResult;
    });
  }
}
